module.exports = __webpack_public_path__ + "static/urban10-69e60b9a0c87a72242337a596f51f524.jpg";